module.exports = __webpack_public_path__ + "img/CU.89e88662.svg";